import { render, staticRenderFns } from "./value_stream_aggregation_status.vue?vue&type=template&id=c6e0b0cc"
import script from "./value_stream_aggregation_status.vue?vue&type=script&lang=js"
export * from "./value_stream_aggregation_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports